import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

const CHUNK_RELOAD_KEY = 'ss_chunk_reload_once';

function isDynamicImportChunkError(value: unknown): boolean {
  const message =
    typeof value === 'string'
      ? value
      : (value as { message?: string } | null)?.message ?? '';

  return message.includes('Failed to fetch dynamically imported module')
    || message.includes('Importing a module script failed');
}

function recoverFromChunkLoadError(error: unknown): void {
  if (!isDynamicImportChunkError(error)) {
    return;
  }

  const alreadyReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1';

  if (alreadyReloaded) {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    return;
  }

  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  window.location.reload();
}

window.addEventListener('error', (event) => {
  recoverFromChunkLoadError(event.error ?? event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  recoverFromChunkLoadError(event.reason);
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    recoverFromChunkLoadError(err);
    console.error(err);
  });
